import * as React from "react";

const SendOutlineThin: React.FC = () => {
    return (
        <svg width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M70.4997 40L15.3009 69.2229C14.6349 69.5755 13.833 69.0927 13.833 68.3391V11.6609C13.833 10.9073 14.6349 10.4245 15.3009 10.7771L70.4997 40ZM60.6355 38.3332L17.1663 15.6672V38.3332H60.6355ZM60.6378 41.6665H17.1663V64.3332L60.6378 41.6665Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(SendOutlineThin);
